export default "__VITE_ASSET__CidtH$bQ__"